import { useEffect, useState } from "react";
import { Link2 } from "lucide-react";
import { api } from "@/lib/api";

// Shows which slots will share one photo for the currently picked templates.
export const SharedSlotsPreview = ({ templateIds = [], testid = "shared-slots-preview" }) => {
  const [groups, setGroups] = useState([]);
  const key = [...templateIds].sort().join(",");

  useEffect(() => {
    if (templateIds.length < 2) { setGroups([]); return undefined; }
    let live = true;
    const t = setTimeout(() => {
      api.post("/templates/photos/shared-preview", { template_ids: templateIds })
        .then((r) => { if (live) setGroups(r.data.groups || []); })
        .catch(() => { if (live) setGroups([]); });
    }, 250);
    return () => { live = false; clearTimeout(t); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);

  if (templateIds.length < 2) return null;

  return (
    <div className="mt-3 rounded-md border border-sky-900/60 bg-sky-950/20 p-3" data-testid={testid}>
      <div className="flex items-center gap-1.5 text-xs font-display font-bold uppercase tracking-wider text-sky-200">
        <Link2 className="w-3.5 h-3.5" aria-hidden="true" />
        Shared photo slots
      </div>
      {groups.length === 0 ? (
        <div className="text-[11px] text-slate-400 mt-1" data-testid={`${testid}-none`}>
          No slots match by name — each template&rsquo;s photos are taken separately.
        </div>
      ) : (
        <>
          <div className="text-[11px] text-slate-400 mt-1 mb-2">
            One photo will fill each of these groups ({groups.length}):
          </div>
          <ul className="space-y-1.5 max-h-48 overflow-y-auto pr-1">
            {groups.map((g, i) => (
              <li key={i} className="text-[11px] text-slate-200 leading-snug" data-testid={`${testid}-group-${i}`}>
                {g.slots.map((sl, j) => (
                  <span key={j}>
                    {j > 0 && <span className="text-sky-400 mx-1">=</span>}
                    <span className="text-slate-400">{sl.template_name} › {sl.category} › </span>
                    {sl.label}
                  </span>
                ))}
              </li>
            ))}
          </ul>
        </>
      )}
    </div>
  );
};

export default SharedSlotsPreview;
